<template>
  <div>
    <ValidationObserver ref="form">
      <form @submit.prevent="handleSubmit">
        <div class="grid">
          <div class="vx-row">
            <div class="vx-col w-full">
              <p class="text-uppercase"><strong>{{ $t('user.UserInfo') }}</strong></p>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vx-input-group class="mb-2 mt-3">
                <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                  <vs-input label-placeholder="Nombre" v-model="name" class="w-full" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vx-input-group class="mb-2 mt-3">
                <ValidationProvider name="Apellidos" rules="required" v-slot="{ errors }">
                  <vs-input label-placeholder="Apellidos" v-model="surname" class="w-full" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vx-input-group class="mb-2 mt-3">
                <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                  <vs-input label-placeholder="Email" v-model="email" class="w-full" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vx-input-group class="mb-2 mt-3">
                <ValidationProvider name="Teléfono" rules="required" v-slot="{ errors }">
                  <vs-input label-placeholder="Teléfono" v-model="phone" class="w-full" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </vx-input-group>
            </div>
            <div class="vx-col w-full mt-4">
              <p class="text-uppercase"><strong>{{ $t('CompanyInfo') }}</strong></p>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vx-input-group class="mb-2 mt-3">
                <ValidationProvider name="Empresa" rules="required" v-slot="{ errors }">
                  <vs-select autocomplete label="Empresa" v-model="company" class="selectCompany w-full">
                    <vs-select-item
                      :key="index"
                      :value="item.id"
                      :text="item.name"
                      v-for="(item, index) in listCompanies"
                    />
                  </vs-select>
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vx-input-group class="mb-2 mt-3">
                <vs-select
                  autocomplete
                  label="Zonas asignadas"
                  :rules="[rules.required]"
                  v-model="e7"
                  multiple
                  class="selectZonas w-full"
                >
                  <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item, index) in zonas" />
                </vs-select>
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vx-input-group class="mb-2 mt-3">
                <ValidationProvider name="Puesto" rules="required" v-slot="{ errors }">
                  <vs-input
                    label-placeholder="Puesto"
                    v-model="job"
                    :rules="[rules.required]"
                    required="true"
                    class="w-full"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </vx-input-group>
            </div>
            <div class="vx-col w-full mt-4 mb-3">
              <p class="text-uppercase"><strong>{{ $t('Notifications') }}</strong></p>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <p class="text-uppercase mb-3">{{ $t('Events') }}</p>
              <label class="mt-2">{{ $t('PushNotifications') }}</label>
              <vs-switch v-model="eventoNoti" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-bell" />
              <label class="mt-2">{{ $t('ByEmail') }}</label>
              <vs-switch v-model="eventoEmail" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-bell" />
              <label class="mt-2">{{ $t('BySMS') }}</label>
              <vs-switch v-model="eventoSms" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-bell" />
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <p class="text-uppercase mb-3">{{ $t('Incidences') }}</p>
              <label>{{ $t('PushNotifications') }}</label>
              <vs-switch v-model="incidenciaNoti" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-bell" />
              <label>{{ $t('ByEmail') }}</label>
              <vs-switch v-model="incidenciaEmail" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-bell" />
              <label>{{ $t('BySMS') }}</label>
              <vs-switch v-model="incidenciaSms" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-bell" />
            </div>
            <div class="vx-col w-full mt-4">
              <p class="text-uppercase"><strong>{{ $t('AccountSecurity') }}</strong></p>
            </div>
            <div class="vx-col w-full">
              <ValidationProvider name="Contraseña" rules="required|min:8|whitespace" v-slot="{ errors }">
                <vx-input-group class="mb-2 mt-3">
                  <vs-input
                    :type="show1 ? 'text' : 'password'"
                    name="input-10-1"
                    placeholder="Contraseña"
                    hint="At least 8 characters"
                    counter
                    outlined
                    v-model="password"
                    class="w-full"
                  ></vs-input>
                  <template slot="append">
                    <div class="append-text bg-primary" @click="show1 = !show1">
                      <span>
                        <feather-icon
                          :icon="show1 ? 'EyeIcon' : 'EyeOffIcon'"
                          :svgClasses="['text-white', 'h-5 w-5 mt-2']"
                        ></feather-icon>
                      </span>
                    </div>
                  </template>
                </vx-input-group>
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
              <small>{{ $t('PasswordSentByEmail') }}</small>
            </div>
            <div class="vx-col w-full text-right mb-3">
              <vs-button color="primary" type="border" @click="generateRandomPassword()" size="small">
                {{ $t('GeneratePassword') }}
              </vs-button>
            </div>
            <div class="vx-col w-full text-right">
              <vs-button depressed color="success" type="border" class="mr-2" @click.prevent="handleSubmit">
                {{ $t('user.CreateUser') }}
              </vs-button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { generateRandomPassword } from '../../utils/helpers';
import { mapActions, mapState } from 'vuex';

export default {
  props: ['dialog'],
  data () {
    return {
      name: '',
      password: '',
      surname: '',
      email: '',
      phone: '',
      company: '',
      job: '',
      show1: false,
      mandatory: true,
      eventoNoti: false,
      eventoEmail: false,
      eventoSms: false,
      incidenciaNoti: false,
      incidenciaEmail: false,
      incidenciaSms: false,
      rules: {
        required: (value) => !!value || 'Required.',
        min: (v) => v.length >= 8 || 'Min 8 characters',
      },
      e7: [],
      zonas: ['Almacen'],
    };
  },
  created () {
    this.getAllCompaniesForSelect();
  },
  computed: {
    ...mapState({
      createdFailed: (state) => state.user.createdFailed,
      listCompanies (state) {
        if (typeof state.companies.listSelect === 'undefined') {
          return {};
        } else {
          return state.companies.listSelect;
        }
      },
    }),
  },
  methods: {
    generateRandomPassword,
    ...mapActions({
      createUser: 'createUser',
      getAllCompaniesForSelect: 'getAllCompaniesForSelect',
    }),
    handleSubmit () {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }

        this.submitted = true;
        const { email, password, name, surname, phone, company, job } = this;

        if (email && password && name && surname && phone && company && job) {
          this.createUser({ email, password, name, surname, phone, company, job });
        }

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },
  },
};
</script>
